import { useCallback, useEffect, useState } from "react";
import { EMPTY_STABLES_HISTORY_TAB_COUNTS } from "../Pages/Private/Stables/constants";
import {
  getStablesHistory,
  getStablesHistoryFilterOptions,
} from "../Services/stablesApi";

const isAllZeroCounts = (counts) => {
  if (!counts || typeof counts !== "object") return true;
  return Object.values(counts).every((value) => !Number(value));
};

const countByHistoryKind = (items = []) => {
  const next = { ...EMPTY_STABLES_HISTORY_TAB_COUNTS };
  next.all = items.length;
  for (const item of items) {
    const kind = item?.historyKind;
    if (kind && Object.prototype.hasOwnProperty.call(next, kind)) {
      next[kind] += 1;
    }
  }
  return next;
};

export const useStablesHistoryFilterOptions = ({ enabled = true, refreshToken = 0 } = {}) => {
  const [tabCounts, setTabCounts] = useState(EMPTY_STABLES_HISTORY_TAB_COUNTS);
  const [loading, setLoading] = useState(Boolean(enabled));
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!enabled) return;

    setLoading(true);
    setError(null);
    try {
      const result = await getStablesHistoryFilterOptions();
      let counts = result.tabCounts ?? EMPTY_STABLES_HISTORY_TAB_COUNTS;

      // Fallback when MS still returns hardcoded zeros but history has rows.
      if (isAllZeroCounts(counts)) {
        try {
          const history = await getStablesHistory({
            type: "all",
            page: 1,
            page_size: 5000,
          });
          if (Array.isArray(history.items) && history.items.length > 0) {
            counts = countByHistoryKind(history.items);
          }
        } catch {
          // Keep filter-options counts (zeros) if history fallback fails.
        }
      }

      setTabCounts(counts);
    } catch (err) {
      setTabCounts(EMPTY_STABLES_HISTORY_TAB_COUNTS);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    if (!enabled || refreshToken <= 0) return;
    load();
  }, [enabled, refreshToken, load]);

  return {
    tabCounts,
    loading,
    error,
    reload: load,
  };
};
